import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ExplorePages() {
  return (
    <section className="py-24 md:py-32" aria-label="Explore our expertise">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 grid md:grid-cols-2 gap-8">
        {[
          { path: "/services", title: "Our Services", text: "Custom software, AI integrations, agentic workflows, and machine learning. See what we build and the projects we’ve delivered.", action: "Explore services" },
          { path: "/industries", title: "Your Industry", text: "Explore the workflows we improve, from ERP and CRM operations to marketing automation and AI-powered products.", action: "Explore industries" },
        ].map((item) => (
          <Link key={item.path} to={item.path} className="glass-card p-8 md:p-10 group">
            <h2 className="font-unbounded text-2xl text-white mb-4">{item.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-8">{item.text}</p>
            <span className="inline-flex items-center gap-2 text-neon-cyan">{item.action}<ArrowUpRight size={18} aria-hidden="true" /></span>
          </Link>
        ))}
      </div>
    </section>
  );
}
